function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPossibleWinner = function SvgPossibleWinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 1.333 1.333"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.333v1.333H0z",
    style: {
      fill: "#ffb42b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.045,
    height: 0.068,
    x: 0.929,
    y: -0.37,
    rx: 0,
    ry: 0,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.959.376a.04.04 0 0 0-.054 0L.892.389l.066.065L.97.441a.04.04 0 0 0 0-.054z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.082,
    height: 0.068,
    x: 0.626,
    y: 0.296,
    rx: 0,
    ry: 0,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.604.254a.04.04 0 0 0-.038.038V.31h.202V.292A.04.04 0 0 0 .73.254z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.667,
    cy: 0.667,
    r: 0.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.667,
    cy: 0.667,
    r: 0.283,
    style: {
      fill: "#9ce5f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.586.53C.518.53.502.587.51.636.522.704.662.8.666.803h.001C.671.8.812.704.823.636.83.586.816.53.748.53.69.53.668.582.667.586.665.582.642.53.586.53",
    style: {
      fill: "#e04f5f"
    }
  }));
};
export default SvgPossibleWinner;